// extracted by mini-css-extract-plugin
export var cancelButton = "_mx-5";
export var content = "_mx-3";
export var createButton = "_mx-6";
export var drawerContainer = "_mx-0";
export var footer = "_mx-2";
export var header = "_mx-1";
export var orderFormColumn = "_mx-4";